import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../store/Application/ApplicationReducer';
import { InitApplicationConfig } from '../../store/Application/ApplicationActions';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private readonly applicationStore: Store<ApplicationState>,
    private router: Router,
  ) {}

  static isLogined(): boolean {
    return localStorage.getItem('currentUser') != null;
  }

  loadUserInfoFromServer(): Promise<any> {
    return this.http
      .get<any>('/bfx/api/application/preload', {})
      .toPromise()
      .then((resp) => {
        this.applicationStore.dispatch(new InitApplicationConfig(resp));
        if (!resp.user || !resp.user.role) {
          localStorage.removeItem('currentUser');
          this.router.navigate(['login']);
          return null;
        }
        localStorage.setItem('currentUser', JSON.stringify(resp.user));
        return resp;
      })
      .catch(() => {
        localStorage.removeItem('currentUser');
        this.router.navigate(['login']);
        return null;
      });
  }
}
